type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: React.ReactNode;
  align?: "start" | "center";
};

export default function SectionHeading({ eyebrow, title, desc, action, align = "start" }: Props) {
  const alignCls = align === "center" ? "mx-auto items-center text-center" : "items-start text-left";
  return (
    <div className={`flex ${align === "center" ? "flex-col" : "flex-col"} ${alignCls} gap-3 md:flex-row md:items-end md:justify-between md:gap-6 ${align === "center" ? "md:flex-col md:items-center md:text-center" : ""}`}>
      <div className="flex max-w-2xl flex-col items-start gap-2.5">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-700">
          <i className="ri-flag-line text-[13px]"></i>
          {eyebrow}
        </span>
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[1.9rem]">{title}</h2>
        {desc && <p className="text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>}
      </div>
      {action && <div className="flex shrink-0 items-center">{action}</div>}
    </div>
  );
}